module.exports = __webpack_public_path__ + "img/upload.2b2f2479.svg";